// src/customer-form/CustomerFileAttachment.jsx
// Uses the same SharedForm.module.css styles for exact visual parity.
import styles from '../styles/forms/SharedForm.module.css';

const UploadIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="17 8 12 3 7 8" />
    <line x1="12" y1="3" x2="12" y2="15" />
  </svg>
);

const CloseIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

export default function CustomerFileAttachment({ attachments, onChange, onRemove }) {
  const handleFileChange = (e) => {
    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      onChange(newFiles);
    }
  };

  return (
    <div className={styles.field}>
      <label className={styles.label}>Attachment(s)</label>

      <label htmlFor="cx-file-upload" className={styles.dropzone}>
        <input
          id="cx-file-upload"
          type="file"
          multiple
          onChange={handleFileChange}
          className={styles.fileInput}
        />
        <div className={styles.dropzoneIcon}>
          <UploadIcon />
        </div>
        <p className={styles.dropzoneText}>Drop files here or click to browse</p>
        <p className={styles.dropzoneHint}>PNG, JPG, PDF up to 10 MB</p>
      </label>

      {attachments.length > 0 && (
        <div className={styles.fileList}>
          <p className={styles.fileListLabel}>Attached files:</p>
          {attachments.map((att, i) => {
            const fileObj = att.file || att;
            return (
              <div key={i} className={styles.fileItem}>
                <span className={styles.fileIcon}><UploadIcon /></span>
                <span className={styles.fileName}>
                  {fileObj.name}
                  {att.isUploading && <span style={{ marginLeft: '8px', color: '#888', fontSize: '0.85em' }}>(Uploading...)</span>}
                  {att.error && <span style={{ marginLeft: '8px', color: 'red', fontSize: '0.85em' }}>({att.error})</span>}
                </span>
                <button
                  type="button"
                  className={styles.fileRemove}
                  onClick={() => onRemove(i)}
                  aria-label="Remove file"
                >
                  <CloseIcon />
                </button>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
